import styled, { css } from "styled-components";
import { lg } from "styles/breakpoint";

export const UserLayoutStyle = styled.div`
  & .ant-layout {
    &-sider {
      background-color: ${(props) => props.theme.colors.black300};
      &-trigger {
        position: absolute;
        background-color: ${(props) => props.theme.colors.black300};
        padding: 0 10px;
      }
      ${lg(css`
        display: none !important;
      `)}
    }
    & .ant-menu {
      background-color: ${(props) => props.theme.colors.black300};
      &-item {
        font-size: 18px;
        margin-top: 10px;
        &-icon {
          font-size: large;
        }
        &-selected {
          background-color: unset;
          color: unset;
        }
        &:has(.active) {
          background-color: ${(props) => props.theme.colors.secondary[900]};
          color: yellow;
        }
      }
      &-title-content {
        margin-left: 14px !important;
        transition: none !important;
      }
    }
    & .ant-menu-item:not(.ant-menu-item-selected):active {
      background-color: ${(props) => props.theme.colors.secondary[900]};
      color: yellow;
    }
  }
`;
